import React from 'react';
import { Translate } from '../../../contexts/Language';
import { Modal } from '../../../components';
import { Row, Col } from 'reactstrap';

export const WithdrawalDetailModal = ({ show, detail, onClose }) => {
    return (
        <Modal
            Show={show}
            Title={Translate('Withdrawal Details')}
            onClose={onClose}
        >
            <div>
                <Row className="mb-2">
                    <Col md={6}><strong>{Translate('ID')}:</strong></Col>
                    <Col md={6}>{detail.id}</Col>
                </Row>
                <Row className="mb-2">
                    <Col md={6}><strong>{Translate('Amount')}:</strong></Col>
                    <Col md={6}>{detail.amount} {detail.currency}</Col>
                </Row>
                <Row className="mb-2">
                    <Col md={6}><strong>{Translate('Status')}:</strong></Col>
                    <Col md={6}>{detail.status}</Col>
                </Row>
                <Row className="mb-2">
                    <Col md={6}><strong>{Translate('Beneficiary')}:</strong></Col>
                    <Col md={6}>{detail.beneficiaryName}</Col>
                </Row>
                <Row className="mb-2">
                    <Col md={6}><strong>{Translate('Payment Method')}:</strong></Col>
                    <Col md={6}>{detail.paymentMethodId}</Col>
                </Row>
                <Row className="mb-2">
                    <Col md={6}><strong>{Translate('Created At')}:</strong></Col>
                    <Col md={6}>{detail.createdAt}</Col>
                </Row>
                {detail.description && (
                    <Row className="mb-2">
                        <Col md={6}><strong>{Translate('Description')}:</strong></Col>
                        <Col md={6}>{detail.description}</Col>
                    </Row>
                )}
            </div>
        </Modal>
    );
};